import { c as _c } from "react/compiler-runtime";
/* eslint-disable no-process-env */
import type { AuthProviderContext, AuthProviderProps, AuthProviderType } from '@newfront-insurance/next-auth';
import type { Provider } from '@newfront-insurance/react-provision';
import type { ReactNode, JSX } from 'react';
interface Props {
  authProvider: Provider<AuthProviderContext, AuthProviderProps>;
  children: ReactNode;
  useConditionalAuthProvider: boolean;
  authProviderType?: AuthProviderType;
}
export function ConditionalAuthProvider(t0) {
  const $ = _c(7);
  const {
    authProvider: AuthProvider,
    useConditionalAuthProvider,
    children,
    authProviderType
  } = t0;
  if (useConditionalAuthProvider) {
    let t1;
    if ($[0] !== AuthProvider || $[1] !== children) {
      t1 = <AuthProvider>{children}</AuthProvider>;
      $[0] = AuthProvider;
      $[1] = children;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== AuthProvider || $[4] !== authProviderType || $[5] !== children) {
    t1 = <AuthProvider providerType={authProviderType}>{children}</AuthProvider>;
    $[3] = AuthProvider;
    $[4] = authProviderType;
    $[5] = children;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}